import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
} from 'reactstrap';
import $ from 'jquery';
import ManagePage from '../../views/ManagePage/';
import ManageStaffPage from '../../views/ManageStaffPage/';

class ListGroupMember extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			_message : '',
			alertClass :'',
			groups : [],
			isadd : 1,
			acyear : '',
			group : this.props.match.params.id,
			accyear : [],
			view : 0,
			_redirect : false,
			members : [],
		}
		this.onChange = this.onChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}	

	onChange(e){
		this.state.group = e.target.value;
		this.getmembers();
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		if (window.confirm("Do you want to Remove?")) { 
		$("#showLoader").show();	
			PostData('group/deletemember',this.state).then((result) => {
				$("#showLoader").hide();	
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Member Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getmembers();
				}
				else{
					this.setState({
						_message:'Error in Remove Member',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}

	componentDidMount() {
		 
		this.getdata();
		this.getacyear();
	}

	componentWillMount(){
		this.getmembers();
	}

	// Get Group
	getdata(){
		$("#showLoader").show();	
		GetData('group/getgroup').then((result) => {
			$("#showLoader").hide();	
			let responseJson = result;
			if(responseJson){
				this.setState({
					groups : responseJson
				});
			}
		});
	}

	/** get Academic Year **/
	getacyear(){
	
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}

	getmembers(){
		if(this.state.group!=''){
			$("#showLoader").show();
			GetData('group/getgroupmembersbyid/'+this.state.group).then((result) => {
				let responseJson = result;
				if(responseJson){
					this.setState({
						members : responseJson
					});
				}
				$("#showLoader").hide();
			});
		}
	}

	onView(e){

		this.setState({_redirect : true});
	}

  render() {
	
		if(this.state._redirect){
			return (<Redirect to={'/group/summary'} />);
		}
		
		var acyear = this.state.accyear;
		var grp = this.state.groups;
		if(this.state.group!=''){
			$("#showdata").show();
		}else{
			$("#showdata").hide();
		}

    return (
		<div>
		  {sessionStorage.getItem('userrole') == 'staff' ?
			<ManageStaffPage /> : <ManagePage /> }
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
					<Card>
					  <CardHeader>List Group Member&nbsp;&nbsp;&nbsp;&nbsp;
							Group : &nbsp;&nbsp;
							<select name="group" onChange={this.onChange} value={this.state.group}> 
								<option value="">Select Group</option>
								{
									grp.map(function (item) {
										return <option value={item.id}>{item.groupname}</option>;
									})
								}
							  </select>
						<button type="button" size="sm" style={{float : 'right'}} onClick={this.onView.bind(this)} className="btn btn-primary" >View</button>
					  </CardHeader>
					  <CardBody>
						<Row id="showdata">
						  <Col md="2" style={{display : 'none'}}>
							<FormGroup>
								<select name="acyear" onChange={this.onChange} id="year">
									<option value="">Select Academic Year</option>
									{
										acyear.map(function (item) {
											return <option value={item.id}>{item.value}</option>;
										})
									}
									</select>
							  </FormGroup>
						  </Col>
						  <Col md="12">
							<table width="100%" style={{border : '1px solid black'}}>
							  <thead>
								<tr>
								  <th style={{border : '1px solid black'}}>S.No</th>
									<th style={{border : '1px solid black'}}>Type</th>
								  <th style={{border : '1px solid black'}}>Member Id</th>
								  <th style={{border : '1px solid black'}}>Name</th>
								  <th style={{border : '1px solid black'}}>Mobile</th>
									<th style={{border : '1px solid black'}}>Manage</th>
								</tr>  
							  </thead>
							  <tbody>
								{this.state.members.length > 0 ?
								  this.state.members.map((item,i) =>
								  <tr key={i}>
										<td style={{border : '1px solid black'}}>{i+1}</td>
										<td style={{border : '1px solid black',textTransform : 'capitalize'}}>{item.type}</td>
										<td style={{border : '1px solid black'}}>{item.memberid}</td>
										<td style={{border : '1px solid black',textTransform : 'uppercase'}}>{item.membername}</td>
										<td style={{border : '1px solid black'}}>{item.mobile}</td>
										<td style={{border : '1px solid black'}}>
											<button className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
										</td>
								  </tr>  
									) : 
									<tr>
										<td colSpan="7"><center>No Members....</center></td>
									</tr>
								}
							  </tbody>
							</table>
						  </Col>
						</Row>
					  </CardBody>
					</Card>	
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default ListGroupMember;


// WEBPACK FOOTER //
// ./src/group/AddGroupMember/ListGroupMember.js